import React from 'react'

const CustomerPendingsContext = React.createContext({
  customerPendings: {},
  setCustomerPendings: () => {},
})

export default CustomerPendingsContext
